import React from "react";
import { useTranslation } from "react-i18next";
import { Space } from "antd";

import { EnrollResultData } from "../../../PatientApplications/enrollTab/submission/EnrollResultData";
import { useSelectedApplication } from "../../../hooks";
import { ReactComponent as AlertIcon } from "../../../../../assets/svg/alert-icon-popup.svg";
import { EnrollGeneralFailure } from "./EnrollGeneralFailure";
import { EnrollBmsCopayLsFailure } from "./EnrollBmsCopayLsFailure";
import { EnrollGenentechFailure } from "../../Genentech/result/EnrollGenentechFailure";
import { usesSupportOnlyFailureMessage, hidesDrugNameInFailureHeader } from "../../templateNames";

const invalidFormDetails = "Invalid form details";

export const EnrollFailed = ({ id, error, padding = "0 15vw" }) => {
  const { t } = useTranslation();
  const application = useSelectedApplication();
  const templateName = application?.ApplicationFormConfigurationTemplateName;
  const useSupportOnlyFailure = usesSupportOnlyFailureMessage(templateName);
  const hideDrugNameInHeader = hidesDrugNameInFailureHeader(templateName);

  const renderFailureContent = () => {
    // EnrollGenentechFailure use only for 422 error
    if (error === invalidFormDetails) {
      return <EnrollGenentechFailure />;
    }
    if (useSupportOnlyFailure) {
      return <EnrollBmsCopayLsFailure error={error} />;
    }
    return <EnrollGeneralFailure error={error} />;
  };

  return (
    <div id={id}>
      <Space
        style={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: padding
        }}
      >
        <EnrollResultData
          icon={<AlertIcon />}
          title={
            hideDrugNameInHeader
              ? t("patientApplications.enroll.enroll_result.application_failed")
              : t("patientApplications.enroll.enroll_result.application_failed_for", {
                  items: application.drugDisplayName
                })
          }
          content={
            <Space
              direction="vertical"
              size={20}
              style={{
                display: "flex",
                textAlign: "center"
              }}
            >
              {renderFailureContent()}
            </Space>
          }
        />
      </Space>
    </div>
  );
};
